var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeCaixaM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4029_9478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3301 45.7031H61.6699V53.0273H13.3301V45.7031Z",
    fill: "#2544B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 11.7188C40.0243 11.7156 42.4443 10.7115 44.2293 8.92655C46.0142 7.14159 47.0184 4.72157 47.0215 2.19727V0H27.9785V2.19727C27.9816 4.72157 28.9858 7.14159 30.7707 8.92655C32.5557 10.7115 34.9757 11.7156 37.5 11.7188Z",
    fill: "#2544B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3301 57.4219V69.873C13.3301 71.2328 13.8702 72.5369 14.8317 73.4984C15.7932 74.4598 17.0973 75 18.457 75H56.543C57.9027 75 59.2068 74.4598 60.1683 73.4984C61.1298 72.5369 61.6699 71.2328 61.6699 69.873V57.4219H13.3301Z",
    fill: "#2544B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.801529 21.6182L13.3303 31.9336V41.3086H61.6702V31.9336L74.199 21.6226C74.4357 21.4279 74.6291 21.1859 74.7667 20.912C74.9042 20.6381 74.983 20.3385 74.9979 20.0324C75.0128 19.7263 74.9635 19.4204 74.8532 19.1345C74.7428 18.8485 74.5739 18.5889 74.3572 18.3721L58.3479 2.35989C57.6016 1.60941 56.7138 1.01441 55.7359 0.609344C54.758 0.204273 53.7096 -0.00282739 52.6511 2.9152e-05H51.4163V2.19729C51.4163 5.88805 49.9501 9.42764 47.3404 12.0374C44.7306 14.6472 41.191 16.1133 37.5003 16.1133C33.8095 16.1133 30.2699 14.6472 27.6602 12.0374C25.0504 9.42764 23.5842 5.88805 23.5842 2.19729V2.9152e-05H22.3494C21.291 -0.00282739 20.2425 0.204273 19.2646 0.609344C18.2868 1.01441 17.399 1.60941 16.6526 2.35989L0.643326 18.3677C0.426641 18.5845 0.257698 18.8441 0.147352 19.1301C0.0370063 19.416 -0.0123012 19.7219 0.00259799 20.028C0.0174972 20.3341 0.0962735 20.6337 0.233865 20.9076C0.371456 21.1815 0.564819 21.4235 0.801529 21.6182Z",
    fill: "#2544B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4029_9478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCaixaM);
export default __webpack_public_path__ + "static/media/icone-caixa-m.ca1a63ced9b16214817fc0b3f1372be1.svg";
export { ForwardRef as ReactComponent };